import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';

// https://fkhadra.github.io/react-toastify/how-to-style/
const Wrap = styled.div`
  --toastify-color-light: var(--black);
  --toastify-color-dark: var(--black);
  /* --toastify-color-info: var(--black); */
  --toastify-color-success: var(--green1c);
  --toastify-color-warning: var(--yellow-dark);
  --toastify-color-error: var(--red1c);
  /* --toastify-color-transparent: rgba(255, 255, 255, 0.7); */

  /* --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error); */

  --toastify-toast-width: 430px;
  /* --toastify-toast-min-height: 64px; */
  /* --toastify-toast-max-height: 800px; */
  --toastify-font-family: var(--standardFontFamily);
  /** Above modals and tooltips */
  --toastify-z-index: 1999999;

  --toastify-text-color-light: var(--white);
  --toastify-text-color-dark: var(--white);

  // Used only for colored theme
  --toastify-text-color-info: var(--white);
  --toastify-text-color-success: var(--green4);
  --toastify-text-color-warning: var(--warnContent);
  --toastify-text-color-error: var(--red3);

  /* --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0; */

  & .Toastify__toast {
    border: 1px solid var(--separator);
  }
  & .Toastify__progress-bar-theme--colored.Toastify__progress-bar--default,
  & .Toastify__progress-bar-theme--colored.Toastify__progress-bar--info {
    background-color: var(--main);
  }
  & .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success {
    background-color: var(--toastify-text-color-success);
  }
  & .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {
    background-color: var(--toastify-text-color-warning);
  }
  & .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
    background-color: var(--toastify-text-color-error);
  }

  & .Toastify__toast-theme--colored.Toastify__toast--default,
  & .Toastify__toast-theme--colored.Toastify__toast--info {
    & .Toastify__close-button {
      color: var(--main);
    }
  }
  & .Toastify__toast-theme--colored.Toastify__toast--success {
    border: 1px solid var(--toastify-text-color-success);
    .Toastify__close-button {
      color: var(--toastify-text-color-success);
    }
  }
  & .Toastify__toast-theme--colored.Toastify__toast--warning {
    border: 1px solid var(--toastify-text-color-warning);
    .Toastify__close-button {
      color: var(--toastify-text-color-warning);
    }
  }
  & .Toastify__toast-theme--colored.Toastify__toast--error {
    border: 1px solid var(--toastify-text-color-error);
    .Toastify__close-button {
      color: var(--toastify-text-color-error);
    }
  }

  @media only screen and (max-width: 480px) {
    /* Adjust padding for mobile */
    .Toastify__toast-container {
      padding: 8px;
      margin-bottom: 58px;
    }
    .Toastify__toast {
      margin: 8px 0;
    }
  }
`;

export default function NotificationsContainer() {
  return (
    <Wrap>
      <ToastContainer
        style={{
          marginTop: 'var(--header-height)',
        }}
        limit={3}
      />
    </Wrap>
  );
}
